import { Api } from "arv-extends";

const { get, post, put, deleteApi, getTokens } = Api;
export { get, post, put, deleteApi, getTokens };
